import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: any;
  public loaded: boolean = false;

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return firstValueFrom(this.http.get('/assets/config.json'))
      .then(config => {
        this.config = config;
        this.loaded = true;
      })
      .catch(error => {
        console.error('Could not load configuration:', error);
        return Promise.reject(error);
      });
  }

  getConfig(): any {
    return this.config;
  }

  isConfigLoaded(): boolean {
    return this.loaded;
  }
}